import { Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import {} from 'react-redux';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
  CartesianGrid,
} from 'recharts';

const ClassWiseEnrollment = ({ Data }) => {
  const [EnrollmentDetails, setEnrollmentDetails] = useState([]);

  useEffect(() => {
    let res = formatData(Data);
    setEnrollmentDetails(res ?? []);
  }, [Data]);
  return (
    <div className='bg-white rounded-lg shadow-sm  size-full'>
      <div className=' p-2 mb-2'>
        <Typography variant='h6' className='w-96 '>
          Class-Wise Enrollment
        </Typography>
      </div>
      {EnrollmentDetails?.length !== 0 ? (
        <div className='overflow-auto w-full'>
          <div
            style={{
              '----w': `${(EnrollmentDetails?.length > 5 ? EnrollmentDetails.length : 6) * 80}px`,
            }}
            className='min-w-[var(----w)] mx-auto'
          >
            <ResponsiveContainer height={260} className=''>
              <BarChart data={EnrollmentDetails} className='pr-5'>
                <XAxis dataKey='name' interval={0} tick={{ fontSize: 12 }} />
                <YAxis domain={[0, 100]} />
                <Tooltip
                  cursor={false}
                  content={({ active, payload, label }) => {
                    if (active && payload && payload.length) {
                      return (
                        <div className='bg-white shadow-lg rounded-md p-3 border text-sm flex flex-col justify-start'>
                          <div className='font-semibold mb-1'>{label}</div>
                          <div className='text-blue-600'>
                            Count: {payload?.[0]?.value}
                          </div>
                          <>
                            {payload?.[0]?.payload?.list?.map((obj, index) => (
                              <span
                                key={index}
                              >{`${obj?.lableName} = ${obj?.count}`}</span>
                            ))}
                          </>
                        </div>
                      );
                    }

                    return null;
                  }}
                />{' '}
                <CartesianGrid
                  stroke='#e5e7eb'
                  strokeDasharray='5 3'
                  vertical={false}
                />
                <Bar
                  dataKey='count'
                  fill='#8dc1ff'
                  radius={[5, 5, 0, 0]}
                  barSize={30}
                  activeBar={{ fill: '#6aaeff' }} // hover color
                />
                <Legend
                  content={
                    <div className='flex gap-2  items-center justify-center'>
                      {' '}
                      <span className='w-5 h-3 rounded-full bg-[#8dc1ff]'></span>{' '}
                      <span>Number of Students</span>
                    </div>
                  }
                />
              </BarChart>
            </ResponsiveContainer>{' '}
          </div>
        </div>
      ) : (
        <div className='size-full h-72 flex justify-center items-center'>
          No Enrollment Details
        </div>
      )}
    </div>
  );
};

export default ClassWiseEnrollment;

function formatData(Data) {
  // ********************** This the data form the Api and converted to the below format

  //  "studentEnrollement": [
  //       {
  //           "department": "M.Sc.",
  //           "totalCount": 20,
  //           "classes": [
  //               {
  //                   "className": "1st Year",
  //                   "count": 11,
  //                   "sections": [
  //                       {
  //                           "section": "Section A",
  //                           "count": 8
  //                       },
  //                       {
  //                           "section": "Section B",
  //                           "count": 3
  //                       }
  //                   ]
  //               },
  //               {
  //                   "className": "2nd Year",
  //                   "count": 9,
  //                   "sections": [
  //                       {
  //                           "section": "Section A",
  //                           "count": 4
  //                       },
  //                       {
  //                           "section": "Section B",
  //                           "count": 5
  //                       }
  //                   ]
  //               }
  //           ]
  //       },
  //       {
  //           "department": "English",
  //           "totalCount": 0,
  //           "classes": []
  //       }
  //   ],
  let obj = Data;
  const result = obj?.map((dept) => {
    let barInfo = {};
    let lablesList = [];
    if (dept.department) {
      barInfo = { name: dept?.department, count: dept?.totalCount };
    }
    if (dept?.classes?.length > 0) {
      lablesList = dept?.classes?.map((classObj) => {
        if (classObj.sections.length > 0) {
          //if sections are there then calcluate the section names and count and return
          return classObj?.sections?.map((sectionObj) => ({
            lableName: classObj?.className + '-' + sectionObj?.section,
            count: sectionObj?.count,
          }));
        } else {
          //if sections not present just return the class names and return
          return { lableName: classObj?.className, count: classObj.count };
        }
      });
    } else {
      lablesList = [];
    }
    return { ...barInfo, list: lablesList?.flat(Infinity) };
  });
  // this is the converted format after flatening the lists in the list
  // [
  //   {
  //     name: 'M.Sc.',
  //     count: 20,
  //     list: [
  //       { lableName: '1st Year-Section A', count: 8 },
  //       { lableName: '1st Year-Section B', count: 3 },
  //       { lableName: '2nd Year-Section A', count: 4 },
  //       { lableName: '2nd Year-Section B', count: 5 },
  //     ],
  //   },
  //   { name: 'English', count: 0, list: [] },
  // ];
  return result;
}
